import type { SingleFunctionTemplateIds } from './single-function-template-ids-type';

export const singleFunctionTemplateIds: SingleFunctionTemplateIds = {
  generalManager: 179,
  hrManager: 181,
  financialManager: 183,
  hseManager: 193,
  safetyRepresentative: 13962,
  infectionControlOfficer: 7956,
  radiationProtectionCoordinator: 6345,
  academicSupervisor: 186,
  equipmentManager: 190,
  ictResponsible: 195,
  qualityManager: 199,
};
